<template>
  <div>
    <PromptControl
      @ok="ok"
      @cancel="cancel"
      @closed="closed"
      v-bind:show="show"
      v-bind:title="lang('lbl_0000056')"
      v-bind:message="lang('lbl_0000057')"
    />
    <ContentWrapperControl class="mt-4">
      <div class="bg-white p-4 rounded-lg shadow">
        <div class="mb-3">
          <TextControl
            @typing="typing"
            v-bind:value="tin"
            name="tin"
            type="tin"
            :maxlength="11"
          />
        </div>
        <div>
          <ButtonControl
            v-if="tin != null"
            v-on:click="update"
            v-bind:disabled="disabled"
          >
            {{ lang("lbl_0000050") }}
          </ButtonControl>
          <span v-else class="mt-1 text-xs text-grey-dark italic">{{
            lang("lbl_0000256")
          }}</span>
        </div>
      </div>
      <PrivacyInfoControl />
    </ContentWrapperControl>
  </div>
</template>

<script>
import { onBeforeRouteLeave } from "vue-router";
import ButtonControl from "./../../components/controls/ButtonControl.vue";
import ContentWrapperControl from "./../../components/controls/ContentWrapperControl.vue";
import PrivacyInfoControl from "@/components/controls/PrivacyInfoControl.vue";
import PromptControl from "./../../components/controls/PromptControl.vue";
import TextControl from "./../../components/controls/TextControl.vue";
import User from "./../../services/User.js";
import mixin from "./../../mixin.js";

export default {
  mixins: [mixin],
  components: {
    ButtonControl,
    ContentWrapperControl,
    TextControl,
    PrivacyInfoControl,
    PromptControl,
  },
  data() {
    return {
      theme: "error",
      display: false,
      message: null,
      changed: false,
      disabled: true,
      show: false,
      tin: null,
      href: null,
    };
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("nofooter", false);
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000066"),
      show: true,
      back: true,
    });

    onBeforeRouteLeave((to) => {
      this.href = to.fullPath;
      if (this.changed) {
        this.show = true;
        return false;
      }
    });

    this.tin = this.$store.state.info.tin || "";
  },
  methods: {
    typing(n) {
      let value = n.value.replace(/[^0-9]/g, "");
      if (value.length > 3 && value.length <= 6) {
        value = value.slice(0, 3) + "-" + value.slice(3);
      } else if (value.length > 6) {
        value =
          value.slice(0, 3) + "-" + value.slice(3, 6) + "-" + value.slice(6, 9);
      }
      this.tin = value;
      this.disabled =
        this.tin.length != 11 || this.tin == this.$store.state.info.tin;
    },
    update() {
      this.$emit("showloader");
      User.updateTin(this.$store.state.key, this.tin)
        .then(() => {
          this.$store.state.info.tin = this.tin;
          this.disabled = true;
          this.changed = false;
          this.$emit("hideloader");
          this.$emit("success", this.lang("lbl_0000068"));
        })
        .catch(function (error) {
          this.$emit("error", error);
        });
    },
    closed() {
      this.display = false;
    },
    cancel() {
      this.show = false;
    },
    ok() {
      this.changed = false;
      this.$router.push(this.href);
    },
  },
  watch: {
    tin(val) {
      this.changed = val != this.$store.state.info.tin;
    },
  },
};
</script>
